// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Delegation entry (memo dev/72): a compact one-task card on the parent's
 * turn. The delegated agent's icon renders as a small circular badge notched
 * into the entry's top-left corner (the approved concept style) — it IS the
 * link to that agent's chat. */

.GZkxBclRFeurh__OcRIg {
  position: relative;
  margin: 8px 0 4px 8px;
  padding: 7px 10px 7px 18px;
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  background: var(--curio-surface-muted);
  font-size: 12px;
}

.a6LOml8VehVmWdFtrDQj {
  border-color: var(--curio-danger-border);
  background: var(--curio-danger-bg);
}

/* The icon notch: overlapping the top-left corner, category-tinted. */
.xY2dhuvnpbWKab4b1fB7 {
  position: absolute;
  top: -9px;
  left: -9px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--curio-card-bg);
  border: 1.5px solid currentColor;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  padding: 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}

button.xY2dhuvnpbWKab4b1fB7 {
  cursor: pointer;
}

button.xY2dhuvnpbWKab4b1fB7:hover,
button.xY2dhuvnpbWKab4b1fB7:focus-visible {
  transform: scale(1.12);
  outline: none;
}

.yaZRsUYJv6z0uXHymznf {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.Qncydbm_Y2nPSnjoxMWQ {
  font-weight: 600;
  color: var(--curio-text-primary);
}

.y6aG32fW1T84HWDnYS_n {
  color: var(--curio-text-secondary);
}

.JGpm4Xp6CFjF6b9OdcTd {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 1px 6px;
  border-radius: 8px;
}

.Fdiv5DHSsDAtdKTrxffR {
  color: var(--curio-success-text);
  background: var(--curio-success-bg);
}

.jcvBIePUuHW1kr5LNm1G {
  color: var(--curio-danger-text);
  background: var(--curio-danger-bg);
}

.Ih8GRmvmsSmaHvQ28fkb {
  margin-top: 3px;
  color: var(--curio-text-secondary);
  overflow-wrap: anywhere;
}

/* Category tints (the palette contract — same values as the chat header). */
.d5ha90x2TgDx1Pux8rU0     { color: var(--curio-category-agent-node-fg); }
.RtgWeSFbpmiQ_zJPKKzM   { color: var(--curio-category-agent-canvas-fg); }
.yTz61y2wzgOL61YHsLjs     { color: var(--curio-category-agent-data-fg); }
.BkFxcswQbo1qcZQed_tQ { color: var(--curio-category-agent-evaluate-fg); }
.TGiNvL00e5dHco4_HGor  { color: var(--curio-category-agent-package-fg); }

/* What the delegated agent ran on: quiet, beside its name. */
.ANwqRaE6ZNduKgXG3iHq {
  color: var(--curio-text-muted);
  font-size: var(--curio-font-size-sm);
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/content/AgentDelegationEntry.module.css"],"names":[],"mappings":"AAAA;;;+BAG+B;;AAE/B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E,4BAAiB,0CAA0C,EAAE;AAC7D,0BAAiB,4CAA4C,EAAE;AAC/D,4BAAiB,0CAA0C,EAAE;AAC7D,wBAAiB,8CAA8C,EAAE;AACjE,yBAAiB,6CAA6C,EAAE;;AAEhE,6DAA6D;AAC7D;EACE,8BAA8B;EAC9B,oCAAoC;AACtC","sourcesContent":["/* Delegation entry (memo dev/72): a compact one-task card on the parent's\n * turn. The delegated agent's icon renders as a small circular badge notched\n * into the entry's top-left corner (the approved concept style) — it IS the\n * link to that agent's chat. */\n\n.entry {\n  position: relative;\n  margin: 8px 0 4px 8px;\n  padding: 7px 10px 7px 18px;\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  background: var(--curio-surface-muted);\n  font-size: 12px;\n}\n\n.failed {\n  border-color: var(--curio-danger-border);\n  background: var(--curio-danger-bg);\n}\n\n/* The icon notch: overlapping the top-left corner, category-tinted. */\n.badge {\n  position: absolute;\n  top: -9px;\n  left: -9px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--curio-card-bg);\n  border: 1.5px solid currentColor;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  padding: 0;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n}\n\nbutton.badge {\n  cursor: pointer;\n}\n\nbutton.badge:hover,\nbutton.badge:focus-visible {\n  transform: scale(1.12);\n  outline: none;\n}\n\n.head {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n\n.title {\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.name {\n  color: var(--curio-text-secondary);\n}\n\n.status {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 1px 6px;\n  border-radius: 8px;\n}\n\n.statusOk {\n  color: var(--curio-success-text);\n  background: var(--curio-success-bg);\n}\n\n.statusFailed {\n  color: var(--curio-danger-text);\n  background: var(--curio-danger-bg);\n}\n\n.summary {\n  margin-top: 3px;\n  color: var(--curio-text-secondary);\n  overflow-wrap: anywhere;\n}\n\n/* Category tints (the palette contract — same values as the chat header). */\n.tint_node     { color: var(--curio-category-agent-node-fg); }\n.tint_canvas   { color: var(--curio-category-agent-canvas-fg); }\n.tint_data     { color: var(--curio-category-agent-data-fg); }\n.tint_evaluate { color: var(--curio-category-agent-evaluate-fg); }\n.tint_package  { color: var(--curio-category-agent-package-fg); }\n\n/* What the delegated agent ran on: quiet, beside its name. */\n.model {\n  color: var(--curio-text-muted);\n  font-size: var(--curio-font-size-sm);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry": `GZkxBclRFeurh__OcRIg`,
	"failed": `a6LOml8VehVmWdFtrDQj`,
	"badge": `xY2dhuvnpbWKab4b1fB7`,
	"head": `yaZRsUYJv6z0uXHymznf`,
	"title": `Qncydbm_Y2nPSnjoxMWQ`,
	"name": `y6aG32fW1T84HWDnYS_n`,
	"status": `JGpm4Xp6CFjF6b9OdcTd`,
	"statusOk": `Fdiv5DHSsDAtdKTrxffR`,
	"statusFailed": `jcvBIePUuHW1kr5LNm1G`,
	"summary": `Ih8GRmvmsSmaHvQ28fkb`,
	"tint_node": `d5ha90x2TgDx1Pux8rU0`,
	"tint_canvas": `RtgWeSFbpmiQ_zJPKKzM`,
	"tint_data": `yTz61y2wzgOL61YHsLjs`,
	"tint_evaluate": `BkFxcswQbo1qcZQed_tQ`,
	"tint_package": `TGiNvL00e5dHco4_HGor`,
	"model": `ANwqRaE6ZNduKgXG3iHq`
};
export default ___CSS_LOADER_EXPORT___;
